import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  card: {
    maxWidth: '388px',
    marginTop: '12px'
  },
  media: {
    height: 0,
    paddingTop: '56.25%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
}));